import { motion } from "framer-motion";
import "./Btn.css";
const Btn = ({ children, className = "", theme = "white", center, submit = false, value, ...props }) => {
    className += ` btn--${theme}`;
    if (center) className += ` btn--center`;
    if (submit) {
        return <motion.input type="submit" whileTap={{ scale: 0.95 }} className={`btn ui ${className || ""}`} value={value} {...props}></motion.input>;
    }
    else {
        return <motion.div whileTap={{ scale: 0.95 }} className={`btn ui ${className || ""}`} {...props}><span className="btn__inner">{children}</span></motion.div>;
    }
};

export default Btn;